import { render } from "./completed-training-sessions.vue?vue&type=template&id=5998151b&scoped=true&ts=true"
import script from "./completed-training-sessions.vue?vue&type=script&lang=ts"
export * from "./completed-training-sessions.vue?vue&type=script&lang=ts"

import "./completed-training-sessions.vue?vue&type=style&index=0&id=5998151b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5998151b"]])

export default __exports__